module.exports = __webpack_public_path__ + "static/img/logo-light-icon.90af902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-light-icon.png
// module id = POok
// module chunks = 17